<template>
  <div>
    <el-container>
      <!--顶栏容器-->
      <el-header>
        <h1>全球电离层地图数据</h1>
      </el-header>

      <!--主要区域容器-->
      <el-main>
        <GetGimSingle /><br><br><br>
        <GetGimGlobe />
      </el-main>

      <!--底栏容器-->
      <el-footer>
      
      </el-footer>
    </el-container>
  </div>
</template>


<script setup>
import GetGimSingle from './components/GetGimSingle.vue'
import GetGimGlobe from './components/GetGimGlobe.vue'
</script>


<style>
#app {
  * {
    margin: 0.4px 1px;
    padding: 0.2px;
  }
}

h1 {
  text-align: center;
  font-family: "SimSun";
}

.el-date-editor{
  --el-date-editor-width: 160px !important;
}
</style>
